export default __webpack_public_path__ + "static/media/backgroundLogo.2efb5ddd.svg";